var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "@irati/store";
import styled from "styled-components";
import session from "@irati/auth/services/session";
import id from "@irati/utils/id";
import Loading from "@irati/ui/src/Loading";
import { Banner } from "@irati/ui/src/Layout";
import History from "@irati/utils/history";
import { idpLogin } from "@irati/sso/services/sso";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import authentication from "@irati/auth";
import loginService from "@irati/auth/services/login";
import FormattedMessage from "@irati/utils/lang";
import IDPLoginError from "./IDPLoginError";
import LoginBlock from "../../../components/LoginBlock";
import LoginPicAndHeader from "../../../components/LoginPicAndHeader/LoginPicAndHeader";
import StyledLoginCard from "../styled/LoginCard";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var LoginSamlIDP = /** @class */ (function (_super) {
    __extends(LoginSamlIDP, _super);
    function LoginSamlIDP() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: null
        };
        _this.getSamlResponse = function () {
            return session.getThenRemove(["SAMLResponse"]).then(function (_a) {
                var SAMLResponse = _a.SAMLResponse;
                if (!SAMLResponse)
                    throw new Error("No Saml Response found");
                return idpLogin(SAMLResponse).then(function (_a) {
                    var userId = _a.userId, accessToken = _a.accessToken;
                    var user = { uuid: userId };
                    var tenant = { uuid: authentication.unAuthedBusiness().uuid };
                    return loginService.ssoLogin(tenant, user, accessToken).then(function () {
                        History.replace("/");
                    });
                });
            });
        };
        return _this;
    }
    LoginSamlIDP.prototype.componentDidMount = function () {
        this.setState({ load: this.getSamlResponse() });
    };
    LoginSamlIDP.prototype.render = function () {
        var load = this.state.load;
        var idNamespace = id("login-saml-idp", this.props, { force: true });
        return (React.createElement("div", { id: idNamespace },
            React.createElement(Banner, { id: id("banner", idNamespace) }),
            React.createElement(LoginBlock, { id: idNamespace },
                React.createElement(StyledLoginCard, { id: id("card", idNamespace), large: true },
                    React.createElement(Wrapper, null,
                        React.createElement(LoginPicAndHeader, { name: idNamespace },
                            React.createElement(FormattedMessage, { id: "platform.login.idp.header" })),
                        React.createElement(Loading, { load: load, Error: IDPLoginError }))))));
    };
    return LoginSamlIDP;
}(PureComponent));
var actions = function (dispatch) {
    return {
        singleSignOn: function (data) { return dispatch(AuthActions.singleSignOn(authentication.userTenant(), data)); }
    };
};
export default connect(null, actions)(LoginSamlIDP);
var templateObject_1;
